import { render, staticRenderFns } from "./AppFilterButton.vue?vue&type=template&id=89ffbd0e&"
import script from "./AppFilterButton.vue?vue&type=script&lang=ts&"
export * from "./AppFilterButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports